<script setup>
    import Button from './../tecto-ui/components/buttons/Button.vue';
    import Icon from './../tecto-ui/components/Icon.vue';
</script>

<template>
    <!-- <Button href="#fb" target="_blank" icon-only>
        <Icon svg="facebook" style="--size: 1.35em;" />
    </Button> -->

    <Button href="https://www.instagram.com/empire225_/" target="_blank" icon-only>
        <Icon svg="instagram" />
    </Button>
</template>